// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__Vt_QR","title":"Header_title__CqCkB","subtitle":"Header_subtitle__tKxk6"};